import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/markdown-calculator',
  component: () => import('../../routes/MarkdownCalculator.svelte'),
  card: {
    id: 'markdown-calculator',
    title: 'Markdown Calculator',
    description: 'Calculate retail markdown percentage, equivalent markup, and find the retail price needed to hit a target markdown.',
    icon: 'sell',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/markdown-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Markdown Calculator – Retail Markdown & Equivalent Markup',
    description: 'Free markdown calculator to find retail markdown percentage, equivalent cost markup, and the retail price needed to achieve a target markdown. Also shows a markdown-to-markup conversion table.',
  },
};

export default meta;